import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { from, map } from 'rxjs';
import { AuthService } from './auth.service';
import { QR_LOGIN_ENABLED } from '../web-auth/web-auth.flags';

// KX admin: /admin is only for the kartexadmin realm role. Runs alongside AuthGuard
// (canActivate: [AuthGuard, adminGuard]) — but on a page refresh the router evaluates both
// guards CONCURRENTLY, and the access token is restored asynchronously (WebCrypto). Checking
// isKartexAdmin() synchronously would read a null token and wrongly bounce the admin to
// /notfound on every F5/deep-link. So wait for the session restore first, then check the role.
export const adminGuard: CanActivateFn = () => {
    const auth = inject(AuthService);
    const router = inject(Router);
    return from(auth.whenSessionReady()).pipe(
        map(() => {
            if (auth.isKartexAdmin()) return true;
            // Oturum yoksa (QR girişi açıkken) kartexadmin girişine; oturum var ama admin değilse /notfound.
            if (QR_LOGIN_ENABLED && !auth.getAccessToken()) return router.createUrlTree(['/auth/admin']);
            return router.createUrlTree(['/notfound']);
        })
    );
};
